module.exports = __webpack_public_path__ + "img/neonatology4.99516cf1.jpg";